import type { Node } from 'react'
import React from 'react'
import styled from 'styled-components'
import { media } from 'app/assets/styles'

type Props = {
    minHeightMobile?: string,
    minHeightDesktop?: string,
    minHeightDesktopLarge?: string,
    children?: Node,
    bgColor?: string,
    bgImg?: string
}

const PlaceholderContainer = styled.div`
    margin: auto;
    background: ${props =>
        props.bgImg ? `url(${props.bgImg}) no-repeat center center` : 'none'};
    background-color: ${props => props.bgColor ?? 'transparent'};
    background-size: cover;
    ${props =>
        props.minHeightMobile ? `min-height: ${props.minHeightMobile}` : ''};
    ${media.medium`
        ${props =>
            props.minHeightDesktop
                ? `min-height: ${props.minHeightDesktop}`
                : ''};
    `};
    ${media.large`
        ${props =>
            props.minHeightDesktopLarge
                ? `min-height: ${props.minHeightDesktopLarge}`
                : ''};
    `};
`

const Placeholder = (props: Props) => {
    return (
        <PlaceholderContainer {...props}>{props.children}</PlaceholderContainer>
    )
}

export { Placeholder }
